import { render, staticRenderFns } from "./pageConfigurationNew.vue?vue&type=template&id=00c2e3dd&scoped=true&"
import script from "./pageConfigurationNew.vue?vue&type=script&lang=js&"
export * from "./pageConfigurationNew.vue?vue&type=script&lang=js&"
import style0 from "./pageConfigurationNew.vue?vue&type=style&index=0&id=00c2e3dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c2e3dd",
  null
  
)

export default component.exports